
<script>
import CloudDisk from './CloudDisk'
export default {
  name: 'ReadGroupCloudDisk',
  extends : CloudDisk,
  data () {
    return {
    }
  },
  watch: {
    '$route': {
      handler (route) {
        const that = this
        if (route.path === '/teaclouddiskop') {
          console.log('----', route.path)
          that.getCurData()
        }
      },
      deep: true
    }
  },
  created () {
    this.isReadOnly = true
    this.teaCloudDiskName = '机构云盘'
  },
  methods: {
    getCurData () {
      if (this.curTree === null) {
        this.curTree = this.rootTree
        this.reloadBreadcrumbList()
      }
      let requestData = {parentid: this.curTree.fileInfo.id, dir: 0}
      this.$api.cloudDisk.getReadGroupFileList(requestData).then((res) => {
        if (res.code === 0) {
          if (res.data == null || res.data === undefined) {
            let curChildren = []
            this.curTree.children = curChildren
          } else {
            let curChildren = this.formatResponseList(res.data)
            // this.curTree.children = []
            this.$set(this.curTree, 'children', curChildren)
            this.checkUploadStatus(curChildren)
            console.log('curTree', this.curTree)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
  .title-container{
    margin: 30px;
  }
  .file-list{
    margin: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/page/cloudDisk/ReadGroupCloudDisk.vue